import attendanceApi from "../api/attendanceApi";

class AttendanceService {

    async calendar(month, year) {

        const response = await attendanceApi.getCalendar(

            month,

            year

        );

        return response.data;

    }

    async day(date) {

        const response = await attendanceApi.getDay(

            date

        );

        return response.data;

    }

    async search(keyword) {

        const response = await attendanceApi.search(

            keyword

        );

        return response.data;

    }

    async summary(month, year) {

        const response = await attendanceApi.getSummary(

            month,

            year

        );


        /* alert(JSON.stringify(response) ); */

        return response.data;

    }

    async activeSessions() {

        const response =
            await attendanceApi.getActiveSessions();

        return response.data;

    }


    async selfMark(
        attendanceSessionId,
        latitude,
        longitude
    ) {

        const response =
            await attendanceApi.selfMark({

                attendance_session_id:
                    attendanceSessionId,

                latitude,

                longitude,

            });

        return response.data;

    }

}

export default new AttendanceService();